import { App } from 'antd';
import { useEffect } from 'react';
import { useRequestErrorStore } from '@/store/requestError.store';

/** 在 Ant Design App 上下文内统一展示请求层错误。 */
export function RequestErrorNotifier() {
  const { message } = App.useApp();
  const notification = useRequestErrorStore((state) => state.notification);
  const clear = useRequestErrorStore((state) => state.clear);

  useEffect(() => {
    if (!notification) {
      return;
    }

    void message.error({
      key: 'global-request-error',
      content: notification.content,
    });
    clear(notification.id);
  }, [clear, message, notification]);

  return null;
}
